import CircleRectIcon from "./CircleRectIcon.jsx";

export default CircleRectIcon;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/circleRectIcon/index.js